var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouseMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 64,
    viewBox: "0 0 101 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3333 26.6667V37.3333C71.3333 42.9913 69.0857 48.4175 65.0849 52.4183C61.0841 56.4191 55.6579 58.6667 50 58.6667C44.342 58.6667 38.9158 56.4191 34.915 52.4183C30.9142 48.4175 28.6666 42.9913 28.6666 37.3333V24C28.6666 19.0493 30.6333 14.3014 34.134 10.8007C37.6346 7.3 42.3826 5.33334 47.3333 5.33334H50C55.6579 5.33334 61.0841 7.58095 65.0849 11.5817C69.0857 15.5825 71.3333 21.0087 71.3333 26.6667Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 5.33334V22.4C50 22.8243 49.8314 23.2313 49.5313 23.5314C49.2313 23.8314 48.8243 24 48.4 24H28.6666",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8998 14.5858C12.6808 15.3668 12.6808 16.6332 11.8998 17.4142L6.82867 22.4853L16.4854 22.4853C17.5899 22.4853 18.4854 23.3807 18.4854 24.4853C18.4854 25.5899 17.5899 26.4853 16.4854 26.4853L6.82843 26.4853L11.8995 31.5564C12.6805 32.3374 12.6805 33.6037 11.8995 34.3848C11.1184 35.1658 9.85212 35.1658 9.07107 34.3848L0.585786 25.8995C-0.195262 25.1185 -0.195262 23.8521 0.585786 23.0711L2 21.6569L2.00012 21.657L2.00026 21.6569L9.07132 14.5858C9.85237 13.8047 11.1187 13.8047 11.8998 14.5858Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5856 34.3848C87.8046 33.6037 87.8046 32.3374 88.5856 31.5564L93.6567 26.4853L84 26.4853C82.8954 26.4853 82 25.5899 82 24.4853C82 23.3807 82.8954 22.4853 84 22.4853L93.6569 22.4853L88.5859 17.4142C87.8048 16.6332 87.8048 15.3668 88.5859 14.5858C89.3669 13.8047 90.6332 13.8047 91.4143 14.5858L99.8996 23.0711C100.681 23.8521 100.681 25.1185 99.8996 25.8995L98.4854 27.3137L98.4852 27.3136L98.4851 27.3137L91.414 34.3848C90.633 35.1658 89.3666 35.1658 88.5856 34.3848Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseMove);
export default __webpack_public_path__ + "static/media/mouse_move.fc94fcd1bcca538c9a4517d7dd33fb8b.svg";
export { ForwardRef as ReactComponent };